import React from 'react';
import { TeamMembersPanel } from '@/components/team/TeamMembersPanel';
import { BookshopInvitesCard } from '@/components/bookshop/BookshopInvitesCard';

const ROLES = [
  { value: 'bookshop_admin',   label: 'Bookshop Admin',   is_admin_role: true,
     description: 'Team, storefront, catalog, uploads, orders, refunds, settings.' },
  { value: 'bookshop_manager', label: 'Bookshop Manager',
     description: 'Orders, uploads, catalog, reports. No team or settings.' },
  { value: 'bookshop_editor',  label: 'Bookshop Editor', is_default: true,
     description: 'Upload books, edit product metadata. No orders/payments.' },
  { value: 'viewer',           label: 'Viewer',
     description: 'Read-only. Useful for accountants doing audits.' },
];

export default function BookshopTeamPage() {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-200">
      <TeamMembersPanel
        apiPath="bookshop"
        roles={ROLES}
        title="Bookshop Team"
        description="Manage who can operate the bookshop — catalog, uploads, orders and settings. Backed by /api/bookshop/team."
      />
      <div className="max-w-5xl mx-auto px-6 pb-6">
        <BookshopInvitesCard roles={ROLES} />
      </div>
    </div>
  );
}
